<template>
    <div class="cardapio-digital-grupo">
        <HeaderLogo/>
        <section class="cardapio-digital-grupo-section">
            <div class="cardapio-digital-grupo-section-titulo">
                <h4 class="title is-4 is-bold">Bem-vindo</h4>
            </div> 
            <div class="cardapio-digital-grupo-section-lista">
                <div class="cardapio-digital-grupo-section-lista-card" v-for="grupo in grupos" :key="grupo.id" @click="redirecionaProduto(grupo.id)">
                    <img 
                        :src="grupo.img" 
                        :alt="grupo.descricao" 
                        :title="grupo.descricao"
                        onerror="this.onerror=null; this.src='./img/semimagem.png'"
                    >
                    <p>{{grupo.descricao}}</p>
                </div>
            </div> 
        </section>
    </div>
</template>

<script>

import HeaderLogo from './HeaderLogo.vue';
import store from '@/store'

export default {
    name: 'ListaGrupo',
    components: {
        HeaderLogo
    },
    methods: {
        redirecionaProduto(idGrupo) {
          this.$router.push({ name: 'Produto', params: {idGrupo}})
        }
    },
    computed: {
        grupos() {
            return store.state.dadosJson.grupos
        }
    },
    beforeCreate() {
        store.commit('exibirOcultarModalLoading', true)
    },
    mounted() {
        store.commit('exibirOcultarModalLoading', false)
    }
}
</script>

<style lang="scss" scoped>
    .cardapio-digital-grupo {
        display: flex;
        align-items: center;
        flex-direction: column;
        padding-bottom: 3rem;
    }

    .cardapio-digital-grupo-section {
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-top: 2vh;
        width: 90vw;
        max-width: 800px;
    }

    .cardapio-digital-grupo-section-lista {
        width: 100%;
    }

    .cardapio-digital-grupo-section-lista-card {
        display: grid;
        grid-template-columns: 1fr 2fr;
        padding: 0.5rem ;
        align-items: center;
        background-color: #EBE8E8;
        border-radius: 20px;
        margin-top: 2vh;
        min-height: 11vh;
        border: 1px solid rgba(51, 51, 51, 0.2);
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        cursor: pointer;

        @media screen and (min-width: 600px) {
          &:hover {
              transform: scale(1.02);
              box-shadow: 0px 20px 20px rgba(51, 51, 51, 0.2);
          }
        }
    }

    .cardapio-digital-grupo-section-lista-card img {
        margin: auto;
        width: 77px;
        height: 63px;
        border-radius: 5px;
    }

    .cardapio-digital-grupo-section-lista-card p {
        font-size: 17px;
        font-weight: 800;
        text-align: left;
        padding: 0.5rem ;
    }

    @media screen and (min-width: 600px) {
        .cardapio-digital-grupo-section-lista {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax( 12rem, 1fr));
            grid-gap: 1rem;
            justify-content: center;

            .cardapio-digital-grupo-section-lista-card {
                display: grid;
                grid-template-columns: 1fr;
                min-height: 14rem;
                min-width: 12rem;
                padding-bottom: 1rem;
            }

            .cardapio-digital-grupo-section-lista-card img {
                margin: auto;
                width: 147px;
                height: 123px;
                border-radius: 10px;
                
            }

            .cardapio-digital-grupo-section-lista-card p{
                font-size: 20px;
                text-overflow: ellipsis;
                overflow: hidden;
                padding: unset;
                text-align: center;
            }
        }
    }

    @media screen and (max-width: 300px) {
        .cardapio-digital-grupo-section-lista-card {
            grid-template-columns: 1fr;
        }
        .cardapio-digital-grupo-section-lista-card img {
            display: none;
        } 
        .cardapio-digital-grupo-section-lista-card p{
            text-align: center;
        }
    }
</style>